import { Routes } from '@angular/router';

import {
	WorkflowStepsData,
	WorkflowStepsComponent,
} from '../shared/components/workflow-steps/workflow-steps.component';
// eslint-disable-next-line @stylistic/max-len
import { DatacenterViewCustomizationComponent } from '../shared/datacenter/view-customization/datacenter-view-customization.component';
import { canActivateForServiceParameter } from '../shared/guards/service.guard';
import { SERVICE_ANALYTICS } from '../shared/models/list';
import {
	ECALL_BY_BATCH_DATACENTER_TYPE,
	ECALL_BY_VOLUME_DATACENTER_TYPE
} from '../shared/models/datacenter-aggrid-view';
import { ListFilterComponent } from '../shared/components/filter/list-filter.component';

import { EcallOffCardComponent } from './components/card/ecall-off-card.component';
import { ECallOffFollowUpComponent } from './components/dashboard/ecall-off-follow-up.component';
import { EcallOffStepsComponent } from './components/ecall-off-steps/ecall-off-steps.component';
// eslint-disable-next-line @stylistic/max-len
import { StepMaterialPickingComponent } from './components/ecall-off-steps/step-material-picking/step-material-picking.component';
// eslint-disable-next-line @stylistic/max-len
import { ByVolumeStepMaterialPickingComponent } from './components/ecall-off-by-volume-steps/by-volume-step-material-picking.component';
import { StepInfoEntryComponent } from './components/ecall-off-steps/step-infoentry/step-infoentry.component';
import { StepSummaryComponent } from './components/ecall-off-steps/step-summary/step-summary.component';
import { EcallOffListComponent } from './components/list/ecall-off-list.component';
// eslint-disable-next-line @stylistic/max-len
import { ByVolumeStepInfoEntryComponent } from './components/ecall-off-by-volume-steps/by-volume-step-infoentry.component';
import { ByVolumeStepSummaryComponent } from './components/ecall-off-by-volume-steps/by-volume-step-summary.component';

const STEPS_DATA: WorkflowStepsData = {
	afterSubmitUrl: '/ecall-off/ecall/list/',
	backUrl: '/home/order-services',
	steps: [
		{
			labelTranslationKey: 'ecall-off.material-picking',
			path: 'stepMatPicking',
		},
		{
			labelTranslationKey: 'ecall-off.information-entry',
			path: 'stepInfoEntry',
		},
		{
			labelTranslationKey: 'ecall-off.summary',
			path: 'stepSummary',
		}
	],
	titleTranslationKey: 'ecall-off.call-off-request'
};

export const routes: Routes = [
	{
		path: '',
		redirectTo: 'dashboard',
		pathMatch: 'full',
		data: { pageName: 'Redirect' }
	},
	{
		path: 'dashboard',
		component: ECallOffFollowUpComponent,
		data: { pageName: 'ECall-Off - Dashboard', service: SERVICE_ANALYTICS.ECALL_OFF }
	},
	{
		path: 'call-off-request',
		component: StepMaterialPickingComponent,
		data: { pageName: 'ECall-Off - Request', service: SERVICE_ANALYTICS.ECALL_OFF }
	},
	{
		path: 'ecall-off-steps',
		component: EcallOffStepsComponent,
		children: [
			{
				path: '',
				redirectTo: STEPS_DATA.steps[0].path,
				pathMatch: 'full',
				data: { pageName: 'Redirect', service: SERVICE_ANALYTICS.ECALL_OFF_VOLUME }
			},
			{
				path: STEPS_DATA.steps[0].path,
				children: [
					{
						path: '',
						component: StepMaterialPickingComponent,
						data: {
							pageName: 'ECall-Off By Batch - Material Picking',
							service: SERVICE_ANALYTICS.ECALL_OFF_BATCH,
							type: ECALL_BY_BATCH_DATACENTER_TYPE
						}
					},
					{
						path: 'view',
						component: DatacenterViewCustomizationComponent,
						data: {
							pageName: 'ECall-Off By Batch - Customization',
							service: SERVICE_ANALYTICS.ECALL_OFF_BATCH,
							type: ECALL_BY_BATCH_DATACENTER_TYPE
						}
					}
				]
			},
			{
				path: STEPS_DATA.steps[1].path,
				component: StepInfoEntryComponent,
				data: { pageName: 'ECall-Off By Batch - Info Entry', service: SERVICE_ANALYTICS.ECALL_OFF_BATCH }
			},
			{
				path: STEPS_DATA.steps[2].path,
				component: StepSummaryComponent,
				data: { pageName: 'ECall-Off By Batch - Summary', service: SERVICE_ANALYTICS.ECALL_OFF_BATCH }
			}
		]
	},
	{
		path: 'ecall-off-by-volume-steps',
		component: WorkflowStepsComponent,
		data: STEPS_DATA,
		children: [
			{
				path: '',
				redirectTo: STEPS_DATA.steps[0].path,
				pathMatch: 'full',
				data: { pageName: 'Redirect', service: SERVICE_ANALYTICS.ECALL_OFF_VOLUME }
			},
			{
				path: STEPS_DATA.steps[0].path,
				canActivate: [canActivateForServiceParameter('PCALL', 'ByVolume', 'True')],
				children: [
					{
						path: '',
						component: ByVolumeStepMaterialPickingComponent,
						data: {
							pageName: 'ECall-Off By Volume - Material Picking',
							service: SERVICE_ANALYTICS.ECALL_OFF_VOLUME,
							type: ECALL_BY_VOLUME_DATACENTER_TYPE
						}
					},
					{
						path: 'view',
						component: DatacenterViewCustomizationComponent,
						data: {
							pageName: 'ECall-Off By Volume - Customization',
							service: SERVICE_ANALYTICS.ECALL_OFF_VOLUME,
							type: ECALL_BY_VOLUME_DATACENTER_TYPE
						}
					}
				]
			},
			{
				path: STEPS_DATA.steps[1].path,
				canActivate: [canActivateForServiceParameter('PCALL', 'ByVolume', 'True')],
				component: ByVolumeStepInfoEntryComponent,
				data: { pageName: 'ECall-Off By Volume - Info Entry', service: SERVICE_ANALYTICS.ECALL_OFF_VOLUME }
			},
			{
				path: STEPS_DATA.steps[2].path,
				canActivate: [canActivateForServiceParameter('PCALL', 'ByVolume', 'True')],
				component: ByVolumeStepSummaryComponent,
				data: { pageName: 'ECall-Off By Volume - Summary', service: SERVICE_ANALYTICS.ECALL_OFF_VOLUME }
			}
		]
	},
	{
		path: 'ecall',
		children: [
			{
				path: '',
				redirectTo: 'list',
				pathMatch: 'full',
				data: { pageName: 'Redirect', service: SERVICE_ANALYTICS.ECALL_OFF },
			},
			{
				path: 'list',
				children: [
					{
						path: '',
						component: EcallOffListComponent,
						data: {
							pageName: 'ECall-Off - List',
							service: SERVICE_ANALYTICS.ECALL_OFF,
						}
					},
					{
						path: 'filter',
						component: ListFilterComponent,
						data: {
							pageName: 'ECall-Off - Filter',
							service: SERVICE_ANALYTICS.ECALL_OFF,
						}
					}
				]
			},
			{
				path: 'card/:id',
				component: EcallOffCardComponent,
				data: { pageName: 'ECall-Off - Card', service: SERVICE_ANALYTICS.ECALL_OFF }
			}
		]
	}
];
